// extracted by mini-css-extract-plugin
export default {"notifications":"Notifications_notifications__8kKOt","notification":"Notifications_notification__F8Imj"};